import React, { useState } from 'react';
import ProductRulesTab from './ProductRulesTab';
import OrderGeneratorTab from './OrderGeneratorTab';
import SmsTemplateTab from './SmsTemplateTab';
import SupplyPriceTab from './SupplyPriceTab';
import { VendorDef, SmsTemplateDef } from './vendors';

export type { SmsTemplateDef };

// smsTemplates 우선, 없으면 smsTemplate(단일)을 배열로 변환
function resolveSmsTemplates(vendor: VendorDef): SmsTemplateDef[] {
  if (vendor.smsTemplates && vendor.smsTemplates.length > 0) return vendor.smsTemplates;
  if (vendor.smsTemplate) return [{ label: '기본', body: vendor.smsTemplate }];
  return [];
}

export default function VendorPage({ vendor }: { vendor: VendorDef }) {
  const [tab, setTab] = useState<'orders' | 'rules' | 'sms' | 'price'>('orders');

  // 주문서 설정(template)이 없는 파트너(예: 머드네농장)는 전용 컴포넌트로 라우팅되므로 여기 오지 않는다.
  if (!vendor.template) return null;
  const template = vendor.template;

  const tabs = [
    { key: 'orders' as const, label: '주문서 생성' },
    { key: 'rules' as const, label: '상품명 관리' },
    { key: 'sms' as const, label: '배송문자' },
    { key: 'price' as const, label: '공급가' },
  ];

  return (
    <div>
      {/* 헤더 - 머드네농장 UI 스타일 */}
      <div className="bg-white border-b border-gray-200 shadow-sm rounded-t-lg mb-6">
        <div className="flex items-center gap-2 px-6 py-3">
          <span className="text-lg font-bold text-gray-800 mr-6">{vendor.name}</span>
          {tabs.map(t => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                tab === t.key ? 'bg-jeju-brown text-white' : 'text-gray-600 hover:bg-gray-100'
              }`}
            >{t.label}</button>
          ))}
        </div>
      </div>

      {/* 콘텐츠 */}
      {tab === 'orders' && <OrderGeneratorTab key={vendor.code} vendorCode={vendor.code} vendorName={vendor.name} template={template} courier={vendor.courier ?? ''} consolidate={!!vendor.consolidate} filenameDateOffset={vendor.filenameDateOffset ?? 0} excludeRules={vendor.excludeRules ?? []} smsTemplates={resolveSmsTemplates(vendor)} />}
      {tab === 'rules' && <ProductRulesTab key={vendor.code} vendor={vendor.code} />}
      {tab === 'sms' && <SmsTemplateTab key={vendor.code} vendorCode={vendor.code} vendorName={vendor.name} legacyTemplates={resolveSmsTemplates(vendor)} />}
      {tab === 'price' && <SupplyPriceTab key={vendor.code} vendorName={vendor.name} ledgerVendorName={vendor.ledgerVendorName} />}
    </div>
  );
}
